/*
 * @Author       : dengjianjun
 * @Date         : 2021-10-22 15:55:32
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @LastEditTime: 2023-04-24 19:01:51
 * @Description  :
 * @FilePath     : /es-template/src/store/modules/train/state.js
 */

import { getStore } from '@/config/usex'
export default getStore()
// import { getStorage } from '@/utils/storage'

// export default {
//   userInfo: getStorage('userInfo') || {},
//   token: getStorage('token') || undefined,
//   loged: false
// }
